import { FilterGroupName, LineTypes, StockOptions } from 'results/constants'
import type { Filters } from 'src/store/models/SearchModels'

export const getAppliedFilterCount = (
  filters: Filters,
  manufacturers: string[]
): number => {
  let count = 0

  filters.forEach((filter) => {
    filter.items.forEach((item) => {
      if (
        filter.groupName === FilterGroupName.LINES &&
        item === LineTypes.ALL_LINES
      ) {
        return
      }
      if (
        filter.groupName === FilterGroupName.STOCK &&
        item === StockOptions.SHOW_ALL
      ) {
        return
      }
      count += 1
    })
  })

  return count + manufacturers.length
}
